import { useMemo } from 'react';
import { AllBrandsStatsResponse } from '../../../../shared/models/projects/stats/AllBrandsStatsResponse';

export const useCurrentBrandGeneralStats = (
  firmName: string,
  allBrandsStatsResponse: AllBrandsStatsResponse[]
) => {
  return useMemo(() => {
    if (!firmName || !allBrandsStatsResponse) {
      return null;
    }

    return allBrandsStatsResponse.find((item) => item.keyword === firmName) || null;
  }, [allBrandsStatsResponse]);
};
